'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".Container-module_container__P04Z6{box-sizing:border-box;margin:0 auto;padding:0}";
var styles = {"container":"Container-module_container__P04Z6"};
styleInject["default"](css_248z, '7a9e4301-f1d9-4daf-90a0-058fb2fbb50c');

exports["default"] = styles;
